import React from 'react';
import { Switch, Route } from 'react-router-dom';

import ModerateCoproducer from './ModerateCoproducer';

const Confirmation = () => {
  return (
    <div>
      <Switch>
        <Route path='/confirmation/coproducer' component={ModerateCoproducer} />
      </Switch>
    </div>
  );
};
export default Confirmation;
